import React from 'react';
import { LayersIcon, GiftIcon, FileTextIcon, ActivityIcon, TimerIcon, FlowerIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
const chips = [{
  icon: LayersIcon,
  label: '6 Volumes'
}, {
  icon: GiftIcon,
  label: '5 Bonuses'
}, {
  icon: FileTextIcon,
  label: '300+ Pages'
}, {
  icon: ActivityIcon,
  label: '30 conditions + 9 populations'
}, {
  icon: TimerIcon,
  label: '90-second Quick Cards'
}, {
  icon: FlowerIcon,
  label: 'Vinyasa, hatha, yin, hot and Ashtanga'
}];
export function Hero() {
  return <header className="w-full bg-paper" data-id="element-169" data-mp="sb1bbp9ejz61">
      <div className="mx-auto grid max-w-content grid-cols-1 items-center gap-10 px-5 py-12 sm:gap-14 sm:px-8 sm:py-24 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16 lg:py-28" data-id="element-170" data-mp="s9zxjd104ykm">
        <div data-id="element-171" data-mp="3d21t5zvq8oos">
          <p className="inline-flex items-center gap-2 rounded-full bg-sage-soft px-4 py-2 font-sans text-[11px] font-semibold uppercase leading-none tracking-[0.14em] text-sage" data-id="element-172" data-mp="3d2lapfhgtb2a">
            <span aria-hidden="true" data-id="element-173" data-mp="3j7zgfm2d3yi9">◆</span>
            Screen &amp; Adapt™ — The Yoga Teacher's Injury Decision System
          </p>

          <h1 className="mt-6 font-serif text-[31px] font-semibold leading-[1.14] tracking-[-0.01em] text-ink sm:mt-7 sm:text-5xl sm:leading-[1.12] lg:text-[58px]" data-id="element-174" data-mp="3o6amdlpjdov7">
            Answer the injuries students actually name — calmly, in under 90 seconds. Without
            turning your class into an intake interview.
          </h1>

          <p className="mt-5 max-w-[38rem] font-sans text-[16px] leading-[1.6] text-ink-soft sm:mt-6 sm:text-lg sm:leading-[1.65]" data-id="element-175" data-mp="30g6mnpfgy99h">
            The complete 6-volume decision system for yoga teachers. 300+ pages of one-page Quick
            Cards, posture-family variations, refer-out signals and word-for-word scripts — covering
            30 conditions and 9 populations. From the eight seconds after they tell you, to today's
            class plan, to the referral that doesn't lose the student.
          </p>

          <ul className="mt-8 flex flex-wrap gap-2" data-id="element-176" data-mp="s1rpyhl8dur4">
            {chips.map(({
            icon: Icon,
            label
          }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-full border border-sage/15 bg-white px-3 py-1.5 font-sans text-[12px] font-medium text-ink-soft" data-id="element-177" data-mp="nbl0ygmt488c">
                <Icon className="h-3.5 w-3.5 text-sage" strokeWidth={1.75} aria-hidden="true" data-id="element-178" data-mp="de6r4zve2hp0" />
                {label}
              </li>)}
          </ul>

          <div className="mt-8 sm:mt-10" data-id="element-179" data-mp="1622kbulr1rh1">
            <CtaButton href="#pricing" data-id="element-180" data-mp="162c9jfyyzulo">Get Screen &amp; Adapt™ — Instant Access</CtaButton>
            <TrustRow className="mt-4 justify-center sm:justify-start" data-id="element-181" data-mp="111es55lsb4l8" />
          </div>
        </div>

        <div className="relative mx-auto w-full max-w-[520px]" data-id="element-182" data-mp="x0csinnygqiq">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/4aabb7a8-fc2b-48e7-a057-faa8589442de.jpg" alt="The six volumes of Screen &amp; Adapt Yoga Edition with a phone showing a condition Quick Card, blocks and a strap." width={1200} height={900} className="h-auto w-full rounded-2xl object-cover shadow-lift" loading="eager" fetchPriority="high" decoding="async" data-id="element-183" data-mp="3ltglflt1eim8" />
        </div>
      </div>
    </header>;
}